import React, { createContext, useContext, useState, useCallback } from 'react';

const VideoContext = createContext(null);

export const useVideo = () => {
  const context = useContext(VideoContext);
  if (!context) {
    throw new Error('useVideo must be used within VideoProvider');
  }
  return context;
};

export const VideoProvider = ({ children }) => {
  const [currentlyPlaying, setCurrentlyPlaying] = useState(null);

  const registerPlaying = useCallback((videoId) => {
    setCurrentlyPlaying(videoId);
  }, []);

  const stopPlaying = useCallback((videoId) => {
    setCurrentlyPlaying(prev => prev === videoId ? null : prev);
  }, []);

  const isPlaying = useCallback((videoId) => {
    return currentlyPlaying === videoId;
  }, [currentlyPlaying]);

  const value = {
    currentlyPlaying,
    registerPlaying,
    stopPlaying,
    isPlaying,
  };

  return (
    <VideoContext.Provider value={value}>
      {children}
    </VideoContext.Provider>
  );
};
